import React from 'react';
import styles from './HowItWorksItems.module.scss';
import MuiIcon from 'components/Icons/MuiIcon';

const ITEMS = [
  {
    label: 'IAF Data',
    body: 'All IAF member accreditation bodies and their MLA signatory status',
  },
  {
    label: 'Accreditation Body Data',
    body: 'Certification bodies they have accredited, including standards, countries, and sectors',
  },
  {
    label: 'Certification Body Data',
    body: 'Certified companies, sites, scopes, and sectors',
  },
];

function HowItWorksItems() {
  return (
    <div>
      {ITEMS.map((item, index) => {
        const {label, body} = item;
        return (
          <div key={index} className={styles['item']}>
            <div className={styles['item-header']}>
              <MuiIcon name="check_circle" />
              {label}
            </div>
            <p>{body}</p>
          </div>
        );
      })}
    </div>
  );
}

export default HowItWorksItems;
